'use client';
import { type FC } from 'react';

import dynamic from 'next/dynamic';

import { useAppSelector } from '@/redux-store/hooks';
import type { IEntityDetailContainerProps } from '../../types/EntityDetailContainer.types';

const ModalContainer = dynamic(() => import('./ModalContainer'), {
    ssr: false,
});

const EntityDetailContainer: FC<IEntityDetailContainerProps> = ({
    children,
    identifier,
}) => {
    const entitySelector = useAppSelector(
        state => state.entityDetail[identifier]
    );

    return (
        <div>
            {children}
            {entitySelector?.data && <ModalContainer identifier={identifier} />}
        </div>
    );
};

export default EntityDetailContainer;
